<div class="velocimetro-card">
  <div class="velocimetro-header">
    <div class="velocimetro-icone">
      <svg viewBox="0 0 24 24" width="20" height="20">
        <path d="M4 18a8 8 0 1 1 16 0" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" />
        <line x1="12" y1="18" x2="16" y2="11" stroke="white" stroke-width="2" stroke-linecap="round" />
        <circle cx="12" cy="18" r="1.6" fill="white" />
      </svg>
    </div>
    <h3 class="velocimetro-titulo">Velocidade</h3>
  </div>

  <div class="velocimetro-container">
    <svg class="velocimetro-svg" viewBox="0 0 200 125" width="200" height="125">
      <defs>
        <linearGradient id="paintVelocimetro" x1="30" y1="105" x2="170" y2="105" gradientUnits="userSpaceOnUse">
          <stop offset="0%" [attr.stop-color]="corAbaixo" />
          <stop [attr.offset]="offsetMinimoInicioTransicao + '%'" [attr.stop-color]="corAbaixo" />
          <stop [attr.offset]="offsetMinimoFimTransicao + '%'" [attr.stop-color]="corIdeal" />
          <stop [attr.offset]="offsetMaximoInicioTransicao + '%'" [attr.stop-color]="corIdeal" />
          <stop [attr.offset]="offsetMaximoFimTransicao + '%'" [attr.stop-color]="corAcima" />
          <stop offset="100%" [attr.stop-color]="corAcima" />
        </linearGradient>
      </defs>

      <path d="M30 105 A70 70 0 0 1 170 105" fill="none" stroke="url(#paintVelocimetro)" stroke-width="16"
        stroke-linecap="round" />

      <line [attr.x1]="marcacaoMinima.x1" [attr.y1]="marcacaoMinima.y1" [attr.x2]="marcacaoMinima.x2"
        [attr.y2]="marcacaoMinima.y2" stroke="#22314f" stroke-width="2" />
      <text [attr.x]="marcacaoMinima.labelX" [attr.y]="marcacaoMinima.labelY" text-anchor="middle"
        class="marcacao-label">{{ velocidadeMinima | arrendondaCasasDecimais:1 }}</text>

      <line [attr.x1]="marcacaoMaxima.x1" [attr.y1]="marcacaoMaxima.y1" [attr.x2]="marcacaoMaxima.x2"
        [attr.y2]="marcacaoMaxima.y2" stroke="#22314f" stroke-width="2" />
      <text [attr.x]="marcacaoMaxima.labelX" [attr.y]="marcacaoMaxima.labelY" text-anchor="middle"
        class="marcacao-label">{{ velocidadeMaxima | arrendondaCasasDecimais:1 }}</text>

      <line x1="100" y1="105" x2="100" y2="45" stroke="#22314f" stroke-width="4" stroke-linecap="round"
        [attr.transform]="'rotate(' + rotacaoPonteiro + ' 100 105)'" />
      <circle cx="100" cy="105" r="7" fill="#22314f" />
    </svg>

    <div class="velocimetro-valor">
      <h2>{{ velocidade | arrendondaCasasDecimais:1 }} km/h</h2>
    </div>

    <div class="velocimetro-inicio">
      <h5>0 km/h</h5>
    </div>

    <div class="velocimetro-fim">
      <h5>{{ escalaMaxima }} km/h</h5>
    </div>
  </div>

  <div class="velocimetro-rodape" *ngIf="dataUtc || horaUtc">{{ dataUtc | date:'dd/MM/yyyy' }} {{ horaUtc }}</div>
</div>